import { Component, ElementRef, Inject, Renderer2, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidadoresService } from '../../services/validadores.service';
import { DatosProcesarFirma } from '../../Models/Proceso-Firma-Datos.models';
import { FirmaDigitalService } from '../../services/firma-digital.service';

@Component({
  selector: 'app-rechazar',
  templateUrl: './rechazar.component.html',
  styleUrls: ['./rechazar.component.css']
})
export class RechazarComponent {

  @ViewChild("datos") divDatos: ElementRef;
  @ViewChild("error") divError: ElementRef;
  @ViewChild("action") divAction: ElementRef;

  titulo: string = 'Rechazar Documento';
  rut: string = '';
  form: FormGroup;

  constructor(public dialogRef: MatDialogRef<RechazarComponent>, @Inject(MAT_DIALOG_DATA) public data: DatosProcesarFirma, 
            private fb: FormBuilder, private validarService: ValidadoresService, private renderer: Renderer2, 
            private firmaDigitalService: FirmaDigitalService) {
    dialogRef.disableClose = true; 
    
    this.form = this.fb.group({
      motivo: ['', Validators.required],
      rut: ['', [Validators.required, Validators.maxLength(10)]],
      token: ['', Validators.required]
    }, {
      validators: this.validarService.validarRut('rut')
    });
  }

  get motivoNoValido() {
    return this.form.get('motivo')?.invalid && this.form.get('motivo')?.touched
  }

  get rutNoValido() {
    return this.form.get('rut')?.invalid && this.form.get('rut')?.touched
  }

  get tokenNoValido() {
    return this.form.get('token')?.invalid && this.form.get('token')?.touched
  }

  salir(){
    this.dialogRef.close('');
  }

  volver() {
    this.titulo = 'Rechazar Documento';
    this.renderer.removeClass(this.divDatos.nativeElement, 'ocultar');
    this.renderer.removeClass(this.divAction.nativeElement, 'ocultar');
    this.renderer.addClass(this.divError.nativeElement, 'ocultar');
  }

  rechazar() {
    if (this.rut !== this.form.get('rut').value) {
      this.form.controls['rut'].setValue(this.rut);
    }

    if (this.data._rut.toUpperCase() === this.form.get('rut').value.toUpperCase() && this.data._hashFirma === this.form.get('token').value) {
      
      this.data._motivo = this.form.get('motivo').value;

      this.firmaDigitalService.rechazarDocumento(this.data).subscribe(response => {
        if (response.ejecucionTarea) {
          this.dialogRef.close('rechazo');
        } else {
          this.dialogRef.close('error');
        }
      }, err => {
        this.dialogRef.close('error');
      });

    } else {
      this.titulo = 'Error de validación';
      this.renderer.addClass(this.divDatos.nativeElement, 'ocultar');
      this.renderer.addClass(this.divAction.nativeElement, 'ocultar');
      this.renderer.removeClass(this.divError.nativeElement, 'ocultar');
    }
  }

  formatoRUT(event: any) {
    let value = event.target.value.replace(/\./g, '').replace('-', '');

    if (value.match(/^(\d{7,8}){1}(\w{1})$/)) {
         value = value.replace(/^(\d{7,8})(\w{1})$/, '$1-$2');
    }
    this.rut = value;
  }
}
